// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading--2rtDe","loading-text":"loading-text--1nGUT"};